import { Wrapper as FacebookPixel } from './facebookPixel'
import { LayoutComponent } from './layoutComponent'
import { Plausible } from './plausible'
import { useProject } from '../../api/project'
import { ShowingSignupResultProvider } from '../../context/showingSignupResult'
import { SignupProvider } from '../../context/signup'
import { SnackbarProvider } from '../../context/snackbar'
import { useProjectId } from '../../hooks/useProjectId'

export const Layout = ({ children }) => {
  const { data: project } = useProject(useProjectId())

  return (
    <ShowingSignupResultProvider>
      <SignupProvider>
        <SnackbarProvider>
          <LayoutComponent project={project}>{children}</LayoutComponent>
        </SnackbarProvider>
        <FacebookPixel />
      </SignupProvider>
      <Plausible />
    </ShowingSignupResultProvider>
  )
}
